export default __webpack_public_path__ + "static/media/bar-chart.17b297a3.png";